const root = '';

export const Paths = {
  root: `${root}/`,
  signIn: `${root}/signin`,
  signUp: `${root}/signup`,
  forgotPassword: `${root}/forgot-password`,
  resetPassword: `${root}/reset-password`,
  news: {
    root: `${root}/news`,
  },
  exercises: {
    root: `/exercises`,
    new: `/new`,
    edit: `/edit`,
  },
  programs: {
    root: `${root}/programs`,
    common: `${root}/common`,
    item: `${root}/item`,
    available: `${root}/available`,
    accessSettings: `${root}/accessSettings`,
    new: `${root}/new`,
    edit: `${root}/edit`,
  },
  people: {
    root: `${root}/people`,
    subscriptions: `${root}/subscriptions`,
    subscribers: `${root}/subscribers`,
    requests: `${root}/requests`,
  },

  users: {
    root: `${root}/users`,
    communities: `${root}/communities`,
    subscriptions: `${root}/subscriptions`,
    subscribers: `${root}/subscribers`,
    requests: `${root}/requests`,
  },
  communities: {
    root: `${root}/communities`,
    main: `${root}/main`,
    my: `${root}/my`,
    subscribers: `${root}/subscribers`,
    new: `${root}/new`,
    edit: `${root}/edit`,
    requests: `${root}/requests`,
  },
  chats: `${root}/chats`,
  trainings: {
    root: `${root}/trainings`,
    current: `${root}/trainings/current`,
    finished: `${root}/trainings/finished`,
    new: `${root}/new`,
    common: `${root}/common`,
    available: `${root}/available`,
    accessSettings: `${root}/accessSettings`,
  },
  moderatorDashboard: {
    root: `${root}/moderator`,
    publicExerciseRequests: (withRoot = true) =>
      withRoot
        ? `${root}/moderator/public-request-exercises`
        : `/public-request-exercises`,
    exercise: (id: string, withRoot = true) =>
      withRoot ? `${root}/moderator/exercises/${id}` : `/exercises/${id}`,
    exerciseEdit: (id: string, withRoot = true) =>
      withRoot
        ? `${root}/moderator/exercises/${id}/edit`
        : `/exercises/${id}/edit`,
    exerciseNew: (withRoot = true) =>
      withRoot ? `${root}/moderator/exercises/new` : `/exercises/new`,
    bugReports: (withRoot = true) =>
      withRoot ? `${root}/moderator/bug-reports` : `/bug-reports`,
    bugReport: (
      id: string,
      withRoot = true,
      tab: 'active' | 'archived' = 'active',
    ) =>
      withRoot
        ? `${root}/moderator/bug-reports/list/${tab}/report/${id}`
        : `/bug-reports/list/${tab}/report/${id}`,
    allExercises: (withRoot = true) =>
      withRoot ? `${root}/moderator/all-exercises` : `/all-exercises`,
    publicExercises: (withRoot = true) =>
      withRoot ? `${root}/moderator/public-exercises` : `/public-exercises`,
    activeBugReports: (withRoot = true) =>
      withRoot ? `${root}/moderator/active-bug-reports` : `/active-bug-reports`,
    archivedBugReports: (withRoot = true) =>
      withRoot
        ? `${root}/moderator/archived-bug-reports`
        : `/archived-bug-reports`,
    randomPosts: (withRoot = true) =>
      withRoot ? `${root}/moderator/random-posts` : `/random-posts`,
    reviewPosts: (withRoot = true) =>
      withRoot ? `${root}/moderator/review-posts` : `/review-posts`,
    support: (withRoot = true) =>
      withRoot ? `${root}/moderator/support` : `/support`,
  },
  adminDashboard: {
    root: `${root}/admin`,
    analytics: `/analytics`,
    exerciseManagement: `/exercise-management`,
    languageManagement: `/language-management`,
    appConfiguration: `/app-configuration`,
    exerciseOptions: `/exercise-options`,
    exerciseProperties: `/exercise-properties`,
    languages: `/languages`,
    translations: `/translations`,
    bugReportTypes: `/bug-report-types`,
    appVariables: `/app-variables`,
    appFeatures: `/app-features`,
    aiPrompts: `/ai-prompts`,
    exerciseLoadFormulas: `/exercise-load-formulas`,
    others: `/others`,
    syncRules: `/sync-rules`,
    sync: `/sync`,
    agreements: `/agreements`,
    syncMuscles: `/muscles`,
    syncExercises: `/exercises`,
    notifications: `/notifications`,
  },
  superAdminDashboard: {
    root: `${root}/superadmin`,
    permissions: `/permissions`,
    adminUsers: `/admin-users`,
    subscriptionPlans: `/subscription-plans`,
    subscriptionPlanPrices: `/subscription-plan-prices`,
    subscriptionRestrictions: `/subscription-restrictions`,
    other: `/other`,
  },
  settings: {
    root: `${root}/settings`,
    settings: `/settings`,
    changePassword: `/change-password`,
  },
};
